export default "__VITE_ASSET__DU0B3Ns9__"